import type { z } from 'zod';

import { vendorDetailsQuerySchema } from './inventory-query-schema';

export const vendorDetailsUpdateSchema = vendorDetailsQuerySchema.omit({ vendor: true });

export type VendorDetailsUpdateSchema = z.infer<typeof vendorDetailsUpdateSchema>;

export const vendorDetailsCreateSchema = vendorDetailsUpdateSchema.omit({ id: true });

export type VendorDetailsCreateSchema = z.infer<typeof vendorDetailsCreateSchema>;
